import styled from 'styled-components';

export default styled.div`
  font-family: 'Graphik LC', sans-serif;
  font-size: 25px;
  font-weight: 900;
  line-height: 1.2;
  text-align: center;
  color: ${({color}) => color ? color : '#151515'};
`;